import axios from "axios";
import Helper from "src/support/Helper";
// import { CODES } from "./status-codes";

const METHOD = {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete",
};

// CHECK BELOW FOR SAMPLE DATA TO BE PASSED
class Api {
    constructor() {    }

    // URL FOR API
    // REFER SAMPLE JSON AT BOTTOM FOR DATA VALUES
    get(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.GET, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    post(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.POST, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    put(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.PUT, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.error(error);
                    reject(error);
                });
        });
    }

    delete(url, data) {
        return new Promise((resolve, reject) => {
            this.api(METHOD.DELETE, url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                    console.error(error);
                });
        });
    }

    api(method, url, data) {
        return new Promise((resolve, reject) => {
            let axiosConfig = {};
            //console.log(this.baseURL, BASEURL_API, BASEURL, url);
            axiosConfig.method = method;
            axiosConfig.url = url;
            axiosConfig.headers = Helper.getCommonHeader(method);
            //console.log(axiosConfig.headers);
            if (data) {
                if (data.params) axiosConfig.params = data.params;
                if (data.data && data.data.responseType && data.data.responseType === "blob")
                    axiosConfig.responseType = "blob";
                if (data.data) axiosConfig.data = data.data;
            }

            axios(axiosConfig)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    //DEFAULT ERROR HANDLING
                    // if (error.response) {
                    // 	if (error.response.status === CODES.UNAUTHORIZED) {
                    // 		message.error(error.response.data.message);
                    // 	} else if (error.response.data.email) {
                    // 		message.error(error.response.data.email.msg);
                    // 	} else if (error.response.data.password) {
                    // 		message.error(error.response.data.password.msg);
                    // 	} else if (error.response.status === CODES.VALIDATION_ERROR)
                    // 		message.error(error.response.data.message);
                    // 	else if (error.response.data.message) message.error(error.response.data.message);
                    // }
                    console.error("TCL: Api -> api -> error", error);
                    reject(error);
                });
        });
    }

    
}



export default Api;
